import { nav } from '@stores/nav'
import { action, computed, observable } from 'mobx'

export default abstract class ViewSettingStore {
  @observable view = nav.queryParams.subSection
  availableViews = []
  @observable.ref settingsByView = {}

  constructor(view: string, availableViews: string[], settingsByViews = {}) {
    this.view = view
    this.availableViews = availableViews
    this.settingsByView = settingsByViews
  }

  @computed get selectedViewSetting() {
    return this.settingsByView[this.view]
  }

  @action
  setView = (view: string) => {
    nav.updateQueryParams({ subSection: view })
    this.view = view
  }

  @action
  setSettings = settings => {
    this.settingsByView = settings
  }
}
